import panelRoutes from "@/router/routes/panelRoutes";
import portalFeatureRoutes from "@/router/routes/portalFeatureRoutes";
import {portalRedirect} from "@/router/portalRedirect";

export default [
    {
        path: "/",
        name: "MainLayout",
        component: () => import("../layouts/MainLayout"),
        // redirect: '/fa/panel/dashboard',
        children: [
            {
                path: "calendar",
                name: "calender",
                component: () => import("../views/calendar"),
            },
            {
                path: "assignconsult",
                name: "paymentProcess",
                component: () => import("../views/indexes/PaymentStatus"),
            },
            {
                path: "process-payment",
                name: "ProcessPayment",
                component: () => import("../views/indexes/ProcessPayment"),
                meta: {
                    auth: true,
                },
            },
            {
                path: "social-login",
                name: "socialLogin",
                component: () => import("../views/indexes/SocalLogin"),
            },
            {
                path: "password/reset/:token",
                name: "ResetPassword",
                component: () => import("../views/indexes/ResetPassword"),
            },
            {
                path: ":lang",
                name: "languageView",
                redirect: portalRedirect('portalHome'),
                component: () => import("../layouts/LanguageView"),
                children: [
                    ...panelRoutes,
                    {
                        path: "legal/:documentId",
                        name: "legalDocument",
                        component: () => import("../views/legal/LegalDocumentPage.vue"),
                    },
                    {
                        path: "user-journey",
                        name: "userJourney",
                        component: () => import("../views/panel/UserJourney.vue"),
                    },
                    {
                        path: "feedback/:uuid",
                        name: "feedback",
                        // Legacy UUID links are retired. Never resolve or submit the UUID in the browser.
                        redirect: (to) => ({name: "portalHome", params: {lang: to.params.lang}}),
                    },
                    {
                        path: "user-check-journey",
                        name: "userCheckJourney",
                        component: () => import("../views/panel/UserCheckJourney.vue"),
                    },
                    {
                        path: "login",
                        name: "login",
                        meta: {
                            guest: true,
                        },
                        component: () => import("../views/panel/LoginView"),
                    },
                    {
                        path: "intake",
                        component: () => import("../views/intake/IntakeView"),
                        meta: {
                            auth: true,
                        },
                        // V2-backend-only: screening + divert + match chain. Static draft steps removed.
                        children: [
                            {
                                path: "",
                                redirect: "screening",
                            },
                            {
                                path: "screening",
                                name: "intakeScreening",
                                component: () => import("../views/intake/IntakeScreeningStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "disp/:kind",
                                name: "intakeDisp",
                                component: () => import("../views/intake/IntakeDispStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "crisis",
                                name: "intakeCrisis",
                                component: () => import("../views/intake/IntakeCrisisStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "matching",
                                name: "intakeMatching",
                                component: () => import("../views/intake/MatchLoadingStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "matches",
                                name: "intakeMatches",
                                component: () => import("../views/intake/MatchResultsStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "therapist/:therapistId",
                                name: "intakeTherapist",
                                component: () => import("../views/intake/MatchProfileStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "slots/:therapistId",
                                name: "intakeSlots",
                                component: () => import("../views/intake/MatchSlotsStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "hold",
                                name: "intakeHold",
                                component: () => import("../views/intake/MatchHoldStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "conflict",
                                name: "intakeConflict",
                                component: () => import("../views/intake/MatchConflictStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "hold-expired",
                                name: "intakeHoldExpired",
                                component: () => import("../views/intake/MatchHoldExpiredStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "checkout",
                                name: "intakeCheckout",
                                component: () => import("../views/intake/MatchCheckoutStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "pay-return",
                                name: "intakePayReturn",
                                component: () => import("../views/intake/MatchPayReturnStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "pay-processing",
                                name: "intakePayProcessing",
                                component: () => import("../views/intake/MatchPayProcessingStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "pay-success",
                                name: "intakePaySuccess",
                                component: () => import("../views/intake/MatchPaySuccessStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "pay-fail",
                                name: "intakePayFail",
                                component: () => import("../views/intake/MatchPayFailStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "pay-mismatch",
                                name: "intakePayMismatch",
                                component: () => import("../views/intake/MatchPayMismatchStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "pay-late",
                                name: "intakePayLate",
                                component: () => import("../views/intake/MatchPayLateStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "session-reschedule",
                                name: "intakeSessionReschedule",
                                component: () => import("../views/booking/SessionRescheduleStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "session-cancel",
                                name: "intakeSessionCancel",
                                component: () => import("../views/booking/SessionCancelStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "bk-t02",
                                name: "intakeBkT02",
                                redirect: to => ({name: "portalHome", params: {lang: to.params.lang || "fa"}}),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "bk-t03",
                                name: "intakeBkT03",
                                redirect: to => ({name: "portalHome", params: {lang: to.params.lang || "fa"}}),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "bk-t04",
                                name: "intakeBkT04",
                                redirect: to => ({name: "portalHome", params: {lang: to.params.lang || "fa"}}),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "bk-t-once",
                                name: "intakeBkTOnce",
                                redirect: to => ({name: "portalHome", params: {lang: to.params.lang || "fa"}}),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "bk-s01",
                                name: "intakeBkS01",
                                redirect: to => ({name: "portalHome", params: {lang: to.params.lang || "fa"}}),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "bk-s02",
                                name: "intakeBkS02",
                                redirect: to => ({name: "portalHome", params: {lang: to.params.lang || "fa"}}),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "bk-s03",
                                name: "intakeBkS03",
                                redirect: to => ({name: "portalHome", params: {lang: to.params.lang || "fa"}}),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "consent",
                                name: "intakeConsent",
                                component: () => import("../views/intake/MatchConsentStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "baseline",
                                name: "intakeBaseline",
                                component: () => import("../views/intake/MatchBaselineStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "letter",
                                name: "intakeLetter",
                                component: () => import("../views/intake/MatchLetterStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "letter-voice",
                                name: "intakeLetterVoice",
                                component: () => import("../views/intake/MatchLetterVoiceStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "client-home",
                                name: "intakeClientHome",
                                component: () => import("../views/intake/MatchClientHomeStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "ready-lock",
                                name: "intakeReadyLock",
                                component: () => import("../views/intake/MatchReadyLockStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "ready-ok",
                                name: "intakeReadyOk",
                                component: () => import("../views/intake/MatchReadyOkStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "session-check",
                                name: "intakeSessionCheck",
                                component: () => import("../views/intake/MatchSessionCheckStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "session-av-check",
                                name: "intakeSessionAvCheck",
                                component: () => import("../views/intake/SessionAvCheckStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "session-wait",
                                name: "intakeSessionWait",
                                component: () => import("../views/intake/SessionWaitStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "session-room",
                                name: "intakeSessionRoom",
                                component: () => import("../views/intake/SessionRoomStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "session-reconnect",
                                name: "intakeSessionReconnect",
                                component: () => import("../views/intake/SessionReconnectStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "session-end",
                                name: "intakeSessionEnd",
                                component: () => import("../views/intake/SessionEndStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "session-outcome",
                                name: "intakeSessionOutcome",
                                redirect: (to) => ({
                                    name: "intakeOutcomeSrs",
                                    params: {lang: to.params.lang || "fa"},
                                }),
                            },
                            {
                                path: "outcome-srs",
                                name: "intakeOutcomeSrs",
                                component: () => import("../views/intake/OutcomeSrsStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "outcome-ors",
                                name: "intakeOutcomeOrs",
                                component: () => import("../views/intake/OutcomeOrsStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "assess-done",
                                name: "intakeAssessDone",
                                component: () => import("../views/intake/AssessDoneStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "assess-miss",
                                name: "intakeAssessMiss",
                                component: () => import("../views/intake/AssessMissStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "th-step1",
                                name: "intakeThStep1",
                                redirect: to => ({name: "portalHome", params: {lang: to.params.lang || "fa"}}),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "th-03",
                                name: "intakeTh03",
                                redirect: to => ({name: "portalHome", params: {lang: to.params.lang || "fa"}}),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "qm-01",
                                name: "intakeQm01",
                                redirect: to => ({name: "portalHome", params: {lang: to.params.lang || "fa"}}),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "qm-step2",
                                name: "intakeQmStep2",
                                redirect: to => ({name: "portalHome", params: {lang: to.params.lang || "fa"}}),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "notify",
                                name: "intakeNotify",
                                component: () => import("../views/intake/NotifyStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "consent-signer",
                                name: "intakeConsentSigner",
                                component: () => import("../views/intake/MatchConsentSignerStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "consent-guard",
                                name: "intakeConsentGuard",
                                component: () => import("../views/intake/MatchConsentGuardStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "match-expired",
                                name: "intakeMatchExpired",
                                component: () => import("../views/intake/MatchExpiredStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "match-gap",
                                name: "intakeMatchGap",
                                component: () => import("../views/intake/MatchGapStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "match-invalid",
                                name: "intakeMatchInvalid",
                                component: () => import("../views/intake/MatchInvalidStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "match-noslot",
                                name: "intakeMatchNoslot",
                                component: () => import("../views/intake/MatchNoslotStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "rematch-offer",
                                name: "intakeRematchOffer",
                                component: () => import("../views/intake/RematchOfferStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "rematch-decide",
                                name: "intakeRematchDecide",
                                component: () => import("../views/intake/RematchDecideStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "rematch-run",
                                name: "intakeRematchRun",
                                component: () => import("../views/intake/RematchRunStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            {
                                path: "rematch-fail",
                                name: "intakeRematchFail",
                                component: () => import("../views/intake/RematchFailStep"),
                                meta: {
                                    auth: true,
                                },
                            },
                            // Old static draft URLs → screening
                            {
                                path: "*",
                                redirect: "screening",
                            },
                        ],
                    },
                    {
                        path: "signin",
                        name: "signin",
                        meta: {
                            guest: true,
                        },
                        component: () => import("../views/panel/SignInView"),
                    },
                    {
                        path: "initialize",
                        name: "TelegramInitialize",
                        // meta: {
                        //     guest: true
                        // },
                        component: () => import("../views/panel/LoginInitializeView"),
                    },
                    {
                        path: "preorder/sign/:orderId",
                        name: "preorder",
                        component: () => import("../views/indexes/Preorder"),
                    },
                    {
                        path: "onboarding-new",
                        name: "onboarding_new",
                        component: () => import("../views/indexes/NewOnboarding"),
                        meta: {
                            auth: true,
                        },
                    },
                    // {
                    //     path: "onboarding-presession",
                    //     name: "onboarding_presession",
                    //     component: () => import('../views/indexes/NewOnboardingPreSession'),
                    //     meta: {
                    //         auth: true,
                    //     }
                    // },
                    {
                        path: "test",
                        component: () => import("../views/indexes/tests/testLayout"),
                        children: [
                            {
                                path: ":testID",
                                name: "testStepper",
                                component: () => import("../views/indexes/tests/testStepper"),
                            },
                            {
                                path: ":testID/interpretation/:userTestId",
                                name: "interpretationTest",
                                component: () =>
                                    import("../views/indexes/tests/testInterpretation"),
                            },
                        ],
                    },
                    {
                        path: "presession",
                        name: "presession",
                        component: () => import("../views/presession/presession"),
                    },
                    {
                        path: "static-presession",
                        name: "staticPresession",
                        meta: {
                            auth: true,
                        },
                        component: () => import("../views/presession/StatisPreSession"),
                    },

                    {
                        path: "presession-journey",
                        name: "newPresession",
                        meta: {
                            auth: true,
                        },
                        component: () => import("../views/presession/newPression.vue"),
                    },

                    {
                        path: "matchmaking-presession",
                        name: "matchmakingPresession",
                        meta: {
                            auth: true,
                        },
                        component: () => import("../views/presession/MatchMakingPreSession"),
                    },
                    {
                        path: "portal",
                        component: () => import("../views/portal/PortalView"),
                        meta: {auth: true},
                        children: [
                            {path: "", redirect: "home"},
                            {
                                path: "home",
                                name: "portalHome",
                                component: () => import("../views/portal/PortalHomeStep"),
                                meta: {auth: true, nav: "home", titleKey: "intake.portal.homeTitle", subtitleKey: "intake.portal.homeSubtitle"},
                            },
                            {
                                path: "sessions",
                                name: "portalSessions",
                                component: () => import("../views/portal/PortalSessionsStep"),
                                meta: {
                                    auth: true,
                                    nav: "sessions",
                                    titleKey: "intake.portal.sessionsTitle",
                                    stickyCta: {to: "portalPackage", label: "intake.portal.sessionsBuyCta"},
                                },
                            },
                            {
                                path: "sessions/detail",
                                name: "portalSessionDetail",
                                component: () => import("../views/portal/PortalSessionDetailStep"),
                                meta: {auth: true, nav: "sessions", titleKey: "intake.portal.sessionDetailTitle"},
                            },
                            {
                                path: "progress",
                                name: "portalProgress",
                                component: () => import("../views/portal/PortalProgressStep"),
                                meta: {auth: true, nav: "progress", titleKey: "intake.portal.progressTitle"},
                            },
                            {
                                path: "progress/letter",
                                name: "portalLetter",
                                component: () => import("../views/portal/PortalLetterStep"),
                                meta: {
                                    auth: true,
                                    nav: "progress",
                                    titleKey: "intake.portal.letterTitle",
                                    subtitleKey: "intake.portal.letterSubtitle",
                                },
                            },
                            {
                                path: "care-history",
                                name: "portalCareHistory",
                                component: () => import("../views/portal/PortalCareHistoryStep"),
                                meta: {auth: true, nav: "progress", titleKey: "intake.portal.progressTitle"},
                            },
                            {
                                path: "care/:episodeId/closure",
                                name: "portalEpisodeClosure",
                                component: () => import("../views/portal/PortalEpisodeClosureStep"),
                                meta: {auth: true, nav: "progress", titleKey: "intake.portal.progressTitle"},
                            },
                            {
                                path: "care/:episodeId/private-letter",
                                name: "portalEpisodeLetter",
                                component: () => import("../views/portal/PortalLetterStep"),
                                meta: {auth: true, nav: "progress", titleKey: "intake.portal.letterTitle", subtitleKey: "intake.portal.letterSubtitle"},
                            },
                            {
                                path: "next-session/pay-return",
                                name: "portalNextSessionPayReturn",
                                component: () => import("../views/portal/PortalNextSessionPayReturnStep"),
                                meta: {auth: true, nav: "sessions", titleKey: "intake.portal.nextSessionPaymentResult"},
                            },
                            {
                                path: "next-session",
                                name: "portalNextSessionBooking",
                                component: () => import("../views/portal/PortalNextSessionBookingStep"),
                                meta: {auth: true, nav: "sessions", titleKey: "intake.portal.nextSessionTitle"},
                            },
                            {
                                path: "payments",
                                name: "portalPayments",
                                component: () => import("../views/portal/PortalPaymentsStep"),
                                meta: {auth: true, nav: "payments", titleKey: "intake.portal.payTitle"},
                            },
                            {
                                path: "payments/packages",
                                name: "portalPackage",
                                component: () => import("../views/portal/PortalPackageStep"),
                                meta: {auth: true, nav: "payments", titleKey: "intake.portal.packTitle"},
                            },
                            {
                                path: "payments/receipt",
                                name: "portalReceipt",
                                component: () => import("../views/portal/PortalReceiptStep"),
                                meta: {auth: true, nav: "payments", titleKey: "intake.portal.invoiceDetailsTitle"},
                            },
                            {
                                path: "payments/refund",
                                name: "portalRefund",
                                component: () => import("../views/portal/PortalRefundStep"),
                                meta: {auth: true, nav: "payments", titleKey: "intake.portal.refundTitle"},
                            },
                            {
                                path: "support",
                                name: "portalSupport",
                                component: () => import("../views/portal/PortalSupportStep"),
                                meta: {auth: true, nav: "support", titleKey: "intake.portal.supportTitle"},
                            },
                            {
                                path: "support/new",
                                name: "portalRequestNew",
                                component: () => import("../views/portal/PortalRequestNewStep"),
                                meta: {auth: true, nav: "support", titleKey: "intake.portal.requestTitle"},
                            },
                            {
                                path: "support/detail",
                                name: "portalRequestDetail",
                                component: () => import("../views/portal/PortalRequestDetailStep"),
                                meta: {auth: true, nav: "support", titleKey: "intake.portal.requestDetailTitle"},
                            },
                            {
                                path: "chat",
                                name: "portalChat",
                                component: () => import("../views/portal/PortalChatStep"),
                                meta: {auth: true, nav: "chat", chat: true, titleKey: "intake.portal.therapistName"},
                            },
                            ...portalFeatureRoutes,
                        ],
                    },
                    {
                        path: "legendary-therapists",
                        name: "PsychTest",
                        component: () => import('../components/PsychTest'),
                        meta: {
                            routeKey: 'PsychTest'
                        }

                    },
                    {
                        path: "campaign",
                        component: () =>
                            import("../views/indexes/campaigns/campaignLayout"),
                        children: [
                            {
                                path: "turkish",
                                name: "turkish_campaign",
                                component: () =>
                                    import("../views/indexes/campaigns/TurkishCamaign"),
                            },
                        ],
                    },
                    {
                        path: "login-with-token",
                        name: "LoginWithToken",
                        component: () => import("../views/LoginWithToken"),
                        meta: {
                            // guest: true
                        },
                    },
                    {
                        path: "free-session",
                        name: "freeSession",
                        redirect: to => ({name: "intakeScreening", params: {lang: to.params.lang || "fa"}}),
                        meta: {
                            routeKey: 'freeSession',
                        }
                    },
                ],
            },
        ],
    },
    {path: "*", redirect: "/fa/login"},
];
